import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface OptionContract {
    symbol: string;
    strike: number;
    type: 'CALL' | 'PUT';
    expiry: string;
    price?: number;
}

@Injectable({
    providedIn: 'root'
})
export class EoptionsService {
    // Market State
    private selectedPairSubject = new BehaviorSubject<string>('BTCUSDT');
    selectedPair$ = this.selectedPairSubject.asObservable();

    // Selected Contract (for Order Place)
    private selectedContractSubject = new BehaviorSubject<OptionContract | null>(null);
    selectedContract$ = this.selectedContractSubject.asObservable();

    private expiriesSubject = new BehaviorSubject<string[]>([]);
    expiries$ = this.expiriesSubject.asObservable();

    private selectedExpirySubject = new BehaviorSubject<string>('');
    selectedExpiry$ = this.selectedExpirySubject.asObservable();

    // API URL
    private apiUrl = environment.optionsApiUrl + 'api/options';

    constructor(private http: HttpClient) { }

    setPair(pair: string) {
        this.selectedPairSubject.next(pair);
        this.getOptionChain(pair).subscribe(); // Trigger fetch
    }

    selectContract(contract: OptionContract) {
        console.log('Contract Selected:', contract);
        this.selectedContractSubject.next(contract);
    }

    setExpiries(expiries: string[]) {
        this.expiriesSubject.next(expiries);
    }

    selectExpiry(expiry: string) {
        this.selectedExpirySubject.next(expiry);
    }

    getOptionChain(symbol: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/chain/${symbol}`);
    }

    getPairs(): Observable<any> {
        return this.http.get(`${this.apiUrl}/pairs`);
    }

    placeOrder(order: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/order`, order);
    }

    getOrderHistory(params?: any): Observable<any> {
        return this.http.get(`${this.apiUrl}/orders`, { params });
    }

    getPositionHistory(params?: any): Observable<any> {
        return this.http.get(`${this.apiUrl}/positions`, { params });
    }

    cancelOrder(symbol: string, orderId: string): Observable<any> {
        return this.http.request('delete', `${this.apiUrl}/order`, { body: { symbol, orderId } });
    }

    getDepth(symbol: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/depth/${symbol}`);
    }

    getKlines(symbol: string, interval: string = '1h'): Observable<any> {
        return this.http.get(`${this.apiUrl}/klines/${symbol}?interval=${interval}`);
    }

    getRecentTrades(symbol: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/trades/${symbol}`);
    }

    // View Mode State (Table vs Chart)
    private viewModeSubject = new BehaviorSubject<'TABLE' | 'CHART'>('TABLE');
    viewMode$ = this.viewModeSubject.asObservable();

    setViewMode(mode: 'TABLE' | 'CHART') {
        this.viewModeSubject.next(mode);
    }
}
